<div id="masthead-status" class="masthead__status" *ngIf="status && status.length !== 0">
  <ul class="masthead__status-group">
    <ng-container *ngTemplateOutlet="mastheadStatusTemplate; context: { status: status }"></ng-container>
  </ul>
</div>
<header [ngClass]="mastheadCssClass" role="banner" id="masthead">
  <button
    id="masthead-nav"
    [class.masthead__hide-nav-trigger]="(!navPresent || screen === 'desktop') && !forceShowHamburger"
    class="masthead__nav-trigger"
    (click)="onHamburgerClickHandler()"
  >
    <svg-icon
      *ngIf="!isToggleIconHamburger"
      name="ico-hamburger-24"
      [svgStyle]="{ 'width.px': '24', 'height.px': '24', fill: '#fafbfd' }"
    >
    </svg-icon>
    <svg-icon
      *ngIf="isToggleIconHamburger"
      name="ico-close-24"
      [svgStyle]="{ 'width.px': '24', 'height.px': '24', fill: '#fafbfd' }"
    >
    </svg-icon>
  </button>

  <div
    [ngClass]="mastheadBrandingClass"
    [style.cursor]="isBrandLink ? 'pointer' : 'auto'"
    [style.max-width]="mastheadBrandingClassMaxWidth"
    (click)="onBrandClickHandler()"
  >
    <ng-container *ngTemplateOutlet="mastheadBrandingContent"></ng-container>
  </div>

  <div class="masthead__content">
    <div #slotLeftContent>
      <ng-content select="[slot=left-content]"></ng-content>
    </div>
    <div #slotPerformanceHooks [ngClass]="mastheadNavigationClass" *ngIf="isEnablePerformanceHooks">
      <ng-content select="[slot=performanceHooks]"></ng-content>
    </div>
    <div #slotNavigation [ngClass]="mastheadNavigationClass">
      <ng-content select="[slot=navigation]"></ng-content>
    </div>
    <div #slotUtilities [ngClass]="mastheadUtitilesClass">
      <ng-content select="[slot=utilities]"></ng-content>
    </div>
  </div>
</header>

<ng-template #mastheadStatusTemplate let-status="status">
  <ng-container>
    <ng-container *ngFor="let node of status; let i = index">
      <ng-container
        *ngTemplateOutlet="mastheadNodeStatusTemplate; context: { node: node, index: i, length: status.length }"
      >
      </ng-container>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #mastheadNodeStatusTemplate let-i="index" let-length="length" let-node="node">
  <li class="masthead__status-item" id="masthead-sattus-item+{{ node.name }}">
    : <strong>{{ node.content }}</strong>
  </li>
</ng-template>

<ng-template #mastheadBrandingContent>
  <svg-icon class="masthead_ge_logo" [svgStyle]="{ color: '#b39cf1' }" [name]="icon" [stretch]="false"> </svg-icon>
  <div class="masthead_separator"></div>
  <h1 *ngIf="name" class="masthead__name" id="masthead-name">{{ name }}</h1>
</ng-template>
